import {Component, isDevMode, OnInit} from '@angular/core';
import {NAVER_CALLBACK_SIGN, NaverLoginService} from "../../shared/services/naver-login/naver-login.service";
import {APP_VERSION} from "../../shared/defines/client.const";

import $ from 'jquery';


@Component({
  selector: 'app-cb-naver',
  templateUrl: './cb-naver.component.html',
  styleUrls: ['./cb-naver.component.scss']
})
export class CbNaverComponent implements OnInit {
  public readonly APP_VERSION = isDevMode() ? APP_VERSION : '';

  naverLoginInstance: any;

  constructor(
    private naverLoginSvc: NaverLoginService,
    // private option: OptionService,
  ) {
    (window as any).$ = $;

    // this.option.startAnim = false;
  }

  ngOnInit(): void {
    this.naverLoginSvc.GetUserProfile().subscribe((naverKey: string) => {

      const message = {
        naverKey,
        origin: NAVER_CALLBACK_SIGN,
      }
      window.opener.postMessage(message, '*');
      window.close();
    });
  }
}
